// ─── KB document formats ────────────────────────────────
// The single declaration of what a knowledge base accepts. Each format states everything a new
// one needs, so tsc — not a convention — forces the decisions: a content type and a parser
// branch. Deliberately free of any node: import, the admin FE bundles this file.
export const KB_DOCUMENT_FORMATS = {
    '.docx': {
        contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        parser: 'docx',
    },
    '.md': { contentType: 'text/plain; charset=utf-8', parser: 'text' },
    '.markdown': { contentType: 'text/plain; charset=utf-8', parser: 'text' },
    '.txt': { contentType: 'text/plain; charset=utf-8', parser: 'text' },
};
export const KB_DOCUMENT_EXTENSIONS = Object.keys(KB_DOCUMENT_FORMATS);
export function kbDocumentFormatOf(filename) {
    const lowered = filename.toLowerCase();
    return KB_DOCUMENT_EXTENSIONS.find((format) => lowered.endsWith(format)) ?? null;
}
//# sourceMappingURL=kb-formats.js.map